import { HttpClient } from './httpClient'
import { API_URL } from './RestAPI'
import apiHeaders from './apiHeaders'

const THEME_API = `${API_URL}/themes`

const fetchThemes = () => {
  return HttpClient.get(`${THEME_API}`, apiHeaders())
}

const fetchTheme = (id) => {
  return HttpClient.get(`${THEME_API}/${id}`, apiHeaders())
}

const createTheme = (data) => {
  return HttpClient.post(`${THEME_API}`, data, apiHeaders())
}

const updateTheme = (id, data) => {
  return HttpClient.put(`${THEME_API}/${id}`, data, apiHeaders())
}

const publishTheme = (id) => {
  return HttpClient.post(`${THEME_API}/${id}/publish`, {}, apiHeaders())
}

const deleteTheme = (id) => {
  return HttpClient.delete(`${THEME_API}/${id}`, apiHeaders())
}

const uploadSectionImage = (themeId, sectionId, formData) => {
  return HttpClient.post(
    `${THEME_API}/${themeId}/sections/${sectionId}/upload`,
    formData,
    apiHeaders()
  )
}

const getPreviewToken = (id) => {
  return HttpClient.post(`${THEME_API}/${id}/preview-token`, {}, apiHeaders())
}

const unpublishTheme = (id) => {
  return HttpClient.post(`${THEME_API}/${id}/unpublish`, {}, apiHeaders())
}

const uploadThemeAsset = (themeId, formData) => {
  return HttpClient.post(
    `${THEME_API}/${themeId}/assets/upload`,
    formData,
    apiHeaders()
  )
}

const createEditDraft = (id) => {
  return HttpClient.post(`${THEME_API}/${id}/edit-draft`, {}, apiHeaders())
}

const ThemeApi = {
  fetchThemes,
  fetchTheme,
  createTheme,
  updateTheme,
  publishTheme,
  deleteTheme,
  uploadSectionImage,
  getPreviewToken,
  unpublishTheme,
  uploadThemeAsset,
  createEditDraft
}

export { ThemeApi }
